














import { Vue, Component, Mixins } from "vue-property-decorator";

import _ from "lodash";

import { use, registerMap, registerTheme, connect, disconnect } from "echarts/core";
import { CanvasRenderer, SVGRenderer } from "echarts/renderers";
import {
  BarChart,
  LineChart,
  PieChart,
  MapChart,
  RadarChart,
  ScatterChart,
  EffectScatterChart,
  LinesChart,
  GraphChart
} from "echarts/charts";
import {
  GridComponent,
  PolarComponent,
  GeoComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  VisualMapComponent,
  DatasetComponent,
  ToolboxComponent,
  DataZoomComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  BarChart,
  LineChart,
  PieChart,
  MapChart,
  RadarChart,
  ScatterChart,
  EffectScatterChart,
  LinesChart,
  GraphChart,
  GridComponent,
  PolarComponent,
  GeoComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  VisualMapComponent,
  DatasetComponent,
  CanvasRenderer,
  SVGRenderer,
  ToolboxComponent,
  DataZoomComponent
]);

@Component({
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins() {
  option: any = {
    tooltip: {
      trigger: "item",
      formatter: "{b} : {c}个 ({d}%)"
    },
    legend: {
      orient: "vertical",
      x: "right",
      data: []
    },
    grid: [
      {
        top: 50,
        width: "40%",
        bottom: 0,
        left: 10,
        containLabel: true
      }
    ],
    xAxis: [
      {
        type: "value"
      }
    ],
    yAxis: [
      {
        type: "category",
        data: []
      }
    ],
    series: [
      {
        type: "bar",
        stack: "chart",
        data: [],
        label: {
          show: true,
          position: "right",
          formatter: "{b} {c}个"
        },
        tooltip: {
          formatter: "{b} {c}个"
        }
      },
      {
        type: "pie",
        radius: [0, "30%"],
        center: ["75%", "50%"],
        label: {
          position: "inner"
        },
        labelLine: {
          show: false
        },
        data: []
      },
      {
        type: "pie",
        radius: ["40%", "55%"],
        center: ["75%", "50%"],
        label: {
          // normal: {
            // position: 'inner',
            formatter: "{b} \n {c}个（{d}%）"
          // }
        },
        data: []
      }
    ]
  };

  ei: any = {};

  async loadData() {
    const res2 = await this.$store.dispatch("statistics/stadiumPieData", {});
    if (res2 && res2.Data) {
      this.option.series[1].data = [];
      this.option.series[2].data = [];
      this.option.legend.data = [];
      this.option.yAxis[0].data = [];
      this.option.xAxis[0].data = [];

      //   console.log(res2.Data);

      this.option.series[2].data.push(res2.Data[0]);
      const arr = _.cloneDeep(res2.Data);
      arr.shift();
      this.option.series[1].data = arr;

      for (const obj of res2.Data) {
        this.option.yAxis[0].data.push(obj.name);
        this.option.series[0].data.push(obj.value);
        this.option.legend.data.push(obj.name);
      }
      // console.log(this.option)
    }
  }

  mounted() {
    this.loadData();
  }
}
